import { ICellRendererParams } from "ag-grid-community";
import { FC, useState } from "react";
import SiteURLsDialog from "components/portfolio/components/SiteURLsDialog";
import { Account, Site } from "types/portfolio";
import dynamic from "next/dynamic";
import useFilterModelHighlightHTML from "components/app/useFilterModelHighlightHTML";
import { OrgId, SiteType } from "types/dashboard/enterprise";
import { classHOC } from "components/app/ClassWrapper";

const CIOrganizationIDRenderer: FC<ICellRendererParams & { type?: string; subType?: string }> = ({
  api,
  value: oriValue,
  data,
  type = "ciOrgId",
  subType,
}) => {
  const [siteDialogStatus, setSiteDialogStatus] = useState(false);
  const [siteCellData, setSiteCellData] = useState<Site[]>([]);
  const [orgCellData, setOrgCellData] = useState<OrgId[]>([]);
  const value: string[] = oriValue === "N/A" ? [] : oriValue?.split(" | ");

  const siteURLsDialogHandleClose = () => {
    setSiteDialogStatus(false);
    setSiteCellData([]);
  };

  const siteURLsDialogHandleOpen = (data: Account & SiteType) => () => {
    setSiteDialogStatus(true);
    if (type === "enterprise") {
      if (!data?.siteKey) {
        data.ciOrgs.forEach((item) => {
          item.siteName = data?.siteName;
          item.clientVersion = data?.clientVersion;
          return item;
        });
        setOrgCellData(data.ciOrgs);
      } else {
        const hasSiteNoOrg: OrgId[] = [
          {
            ciOrgId: data?.ciOrgId,
            healthScore: data?.healthScore,
            siteName: data?.siteName,
            clientVersion: data?.clientVersion,
          },
        ];
        setOrgCellData(hasSiteNoOrg);
      }
    } else {
      setSiteCellData(data.sites);
    }
  };

  const validValues = value.filter((x) => x !== "N/A");

  return (
    <div>
      {value.length ? (
        // if have two orgid, only show orgid !== N/A count
        validValues.length === 1 ? (
          <span>{validValues?.[0]}</span>
        ) : (
          <>
            <div
              onClick={siteURLsDialogHandleOpen(data)}
              style={{ cursor: "pointer", color: "dodgerblue" }}
              dangerouslySetInnerHTML={{
                __html: useFilterModelHighlightHTML(api, `Show All (${validValues.length})`),
              }}
            />
            <SiteURLsDialog
              siteDialogStatus={siteDialogStatus}
              siteURLsHandleClose={siteURLsDialogHandleClose}
              siteCellData={type === "enterprise" ? orgCellData : siteCellData}
              type={type}
              subType={subType}
            />
          </>
        )
      ) : oriValue ? (
        <span>N/A</span>
      ) : null}
    </div>
  );
};

export default dynamic(() => Promise.resolve(classHOC(CIOrganizationIDRenderer)), {
  ssr: false,
});
